module.exports = __webpack_public_path__ + "img/s.08fc59c9.svg";